import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { CartFragment } from '../../../graphql/magento'
import CreditCardLogo from '../../CreditCardLogo'
import PaymentDeclinedMessage from './PaymentDeclinedMessage'
import SummarySectionHeader from './SummarySectionHeader'

const StyledCreditCardLogo = styled(CreditCardLogo)`
  font-size: 22px;
  margin-right: 8px;
`

export interface CreditCardPaymentMethodSummaryProps {
  className?: string
  error?: string
  selectedPaymentMethod: CartFragment['selected_payment_method']
  showEdit?: boolean
}

const CreditCardPaymentMethodSummary: React.FC<CreditCardPaymentMethodSummaryProps> = ({
  className,
  error,
  selectedPaymentMethod,
  showEdit = false,
}) => {
  if (!selectedPaymentMethod || selectedPaymentMethod.code !== 'paradoxlabs_cybersource') {
    return null
  }

  return (
    <Grid className={className} container item xs={12}>
      <SummarySectionHeader title="Payment Method" navigateTo="payment/" showEdit={showEdit} />
      <PaymentDeclinedMessage error={error} />
      {selectedPaymentMethod.tokenbase_data ? (
        <Grid container item wrap="nowrap" xs={12} className="fs-exclude">
          <Grid item>
            <StyledCreditCardLogo ccType={selectedPaymentMethod.tokenbase_data.cc_type ?? ''} />
          </Grid>
          <Grid alignItems="flex-start" container item>
            <Grid item xs={12}>
              <Typography color={error ? 'error' : 'initial'} variant="body2">
                Ending in {selectedPaymentMethod.tokenbase_data.cc_last4}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color={error ? 'error' : 'initial'} variant="body2">
                Expires {selectedPaymentMethod.tokenbase_data.cc_exp_month}/
                {selectedPaymentMethod.tokenbase_data.cc_exp_year}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Typography variant="body2">Payment details not available</Typography>
      )}
    </Grid>
  )
}

CreditCardPaymentMethodSummary.defaultProps = {
  className: '',
  error: '',
  showEdit: false,
}

const StyledCreditCardPaymentMethodSummary = styled(CreditCardPaymentMethodSummary)`
  border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  padding: 15px 15px 20px;
  @media (min-width: 600px) {
    border-left: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
    border-right: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  }
  @media (min-width: 960px) {
    &:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
      border-radius: 0 0 4px 4px;
    }
  }
`

export default StyledCreditCardPaymentMethodSummary
